module.exports = __webpack_public_path__ + "static/media/1.bf2c4eef.png";